import React from "react";
import PropTypes from "prop-types";

const Iframe = ({
  src,
  width,
  height,
  title,
  allow,
  allowFullScreen,
  ...rest
}) => {
  return (
    <iframe
      src={src}
      width={width}
      height={height}
      title={title ?? "iframe"}
      allow={allow}
      allowFullScreen={allowFullScreen}
      {...rest}
    />
  );
};

export default Iframe;
